
import {Options, Vue} from 'vue-class-component';
import {mapGetters} from 'vuex'
import InfoBlock from "@/base-components/InfoBlock.vue";
import config from '@/config.json';
import store from '@/store';
import { resolveGameUrl } from '@/utils/gameUrl';

@Options({
  props: {
    isBtnAvalebl: Boolean,
    game:String,
    name: String,
    image: String,
    description: String,
    src: String,
    url: String,
    inDev: [String, Boolean],
    msg: String,
    AboutUs: String,
    AboutUsText: String,
    OurTeam: String,
    OurTeamText: String,
    OurProduct: String,
    OurProductText: String,
  },
  computed: {
    ...mapGetters(['getJsonData', 'isAuthenticated', 'getPlayerSid']),
    jsonData() {
      const jsonData = this.getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, "<br>");
      return JSON.parse(jsonDataWithBreaks);
    },
    urlGame() {
      return this.url;
    },
    showCardScrim() {
      return config.showCardScrim;
    },
    showGameDescription() {
      return config.showGameDescription;
    },
    showCardInfoButton() {
      return config.showCardInfoButton;
    },
    showCardTitle() {
      return config.showCardTitle;
    },
    showFooterBackdrop() {
      return config.showFooterBackdrop;
    },
    descriptionText() {
      return this.description ? this.jsonData[this.description] : '';
    },
    isInDev() {
      return this.inDev === true || this.inDev === 'true';
    }
  },

  methods: {
    processName(name: string) {
      return name.replace(/_/g, " ");
    },
    playInCoins() {
      const sid = this.getPlayerSid;
      const sessionUrl = this.url + (this.url.includes('?') ? '&' : '?') + 'sid=' + encodeURIComponent(sid);
      store.commit('setUrlInPopUp', { game: this.game, url: resolveGameUrl(sessionUrl, this.name), visible: true });
    }
  },

  components: {
    InfoBlock
  },
})
export default class DemoGame extends Vue {
  msg!: string
}
